import { useStatic } from '~/common/hooks/useStatic';
import {
  authorizedRequestFactory,
  RequestConfig,
  RequestPerformer,
} from '~/common/services/requests';
import { useEventHandler } from '../../../../hooks/useEventHandler';
import { useModuleScope } from '../../../ModuleScopeContext';
import { useAuthApi } from '../useAuthApi';
import { getAuthConfig } from './logic/getAuthConfig';

export const useAuthorizedInceptRequest = (): RequestPerformer => {
  const { getAccessToken, getTwoFactorToken } = useAuthApi();
  const context = useModuleScope();

  const buildAuthConfig = useEventHandler((config: RequestConfig) =>
    getAuthConfig(config, getAccessToken(), getTwoFactorToken(), context),
  );

  // the factory owns the in-flight cancellation registry
  return useStatic(() => authorizedRequestFactory(buildAuthConfig));
};
